import { render, staticRenderFns } from "./OwnerSettings.vue?vue&type=template&id=64ab0bea&scoped=true&"
import script from "./OwnerSettings.vue?vue&type=script&lang=js&"
export * from "./OwnerSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64ab0bea",
  null
  
)

export default component.exports